var modules_5e1660a2 = {"container":"_1o9777q","size-2":"_1quw4sq","size-4":"_bkiq8q","size-8":"_1jndn2j","size-12":"_j7hz4t","size-16":"_a52asb","size-20":"_jj2tk","size-24":"_hqrr6j","size-28":"_1pp959y","size-32":"_wqv7xy","size-36":"_1uv3e69","size-40":"_zdq8c5","type-solid":"_1ydbkr8","type-dash":"_1vgrv3u","color-dark":"_b2knty","color-light":"_ej8tj4"};
import "../../../assets/-8Rxbf50.css";

export { modules_5e1660a2 as default };
//# sourceMappingURL=Divider.module.less.js.map
